export const getTotal = (slug, array) => {
  let num = 0
  array.filter(item => {
    if (item.fieldValue === slug) num = item.totalCount
  })

  return num
}
